<aside aria-labelledby="maintenance-day-title">
  <header>
    <div>
      <h2 id="maintenance-day-title">Interventions du {{ dateLabel() }}</h2>
      <p>{{ interventions().length }} intervention{{ interventions().length > 1 ? 's' : '' }}</p>
    </div>
    <button #fermerBouton type="button" class="day-close" aria-label="Fermer les interventions de la journée" (click)="fermer.emit()">
      <span class="material-symbols-outlined" aria-hidden="true">close</span>
    </button>
  </header>
  <div class="day-list">
    @for (item of interventions(); track item.key) {
      <button type="button" class="day-intervention" [style.background]="item.color" (click)="ouvrirIntervention.emit(item.key)">
        <strong>{{ item.installation }}</strong>
        <span>{{ item.intervenant }}</span>
        <span class="day-time">{{ item.horaire }}</span>
      </button>
    } @empty {
      <p>Aucune intervention pour cette journée.</p>
    }
  </div>
</aside>
